import { Box, styled } from "@mui/material";

export const StyledCreateInvoiceDataInput = styled(Box)(({theme}) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    gap: "2rem",
    alignItems: "center",
    justifyContent: "center",
    ".selectProject": {
      width: "60%",
      "& .MuiInputBase-root": {
        width: "100%",
      },
    },
    ".row": {
      display: "flex",
      gap: "5rem",
      alignItems: "center",
      ".column": {
        display: "flex",
        flexDirection: "column",
        minHeight: "5rem",
        justifyContent: "space-between",
        ".checkWrapper": {
          display: "flex",
          alignItems: "center",
        },
      },
    },
    ".vatOptions": {
      width: "60%",
      display: "flex",
      alignItems: "center",
      gap: "1rem",
      justifyContent: "center",
      "& .MuiToggleButton-root": {
        width: "20rem",
        fontSize: "2rem",
      },
      "& .Mui-selected": {
        backgroundColor: "primary.main",
        "&:hover": {
          backgroundColor: "primary.dark",
        },
      },
    },
    ".submitBtn": {},
}))